import React from 'react';
import TimeZoneWidget from '../TimeZone/TimeZoneWidget';
import PropTypes from 'prop-types';
import ClassNames from 'nucleus-widgets/lib/Date/Date.less';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import DateTime from 'nucleus-widgets/lib/DateTime/DateTime';
import { resolveTestId } from '@cvent/nucleus-test-automation';

class EventDateTimeWidget extends BaseWidget {
  static propTypes = {
    type: PropTypes.string,
    config: PropTypes.shape({
      displayDateOption: PropTypes.string
    }),
    switchTimeZone: PropTypes.func,
    classes: PropTypes.any,
    style: PropTypes.any,
    translate: PropTypes.func.isRequired,
    // Non-configurable appData props.
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    timeZone: PropTypes.string.isRequired,
    translateDate: PropTypes.func.isRequired,
    translateTime: PropTypes.func.isRequired
  };

  static defaultProps = {
    classes: ClassNames
  };

  getStyleObject() {
    return {
      ...super.getStyleObject(),
      date: this.getElementInlineStyle('date'),
      timeTimeZone: this.getElementInlineStyle('timeTimeZone')
    };
  }

  render() {
    const { switchTimeZone, classes, config, startDate, endDate, timeZone, translateTime, translateDate,
      translate } = this.props;
    const displayFormat = config.displayDateOption;
    const styleObject = this.getStyleObject();
    const internalContainerStyle = {
      backgroundColor: 'transparent',
      borderRadius: 0,
      flex: '1 1 auto',
      paddingBottom: 5,
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 15,
      pointerEvents: 'none'
    };
    const internalStyleObject = {
      ...styleObject,
      container: internalContainerStyle
    };
    return (
      <div style={styleObject.container}>
        <DateTime
          {...resolveTestId(this.props)}
          startDate={startDate}
          endDate={endDate}
          timeZone={timeZone}
          displayFormat={displayFormat}
          translate={translate}
          translateDate={translateDate}
          translateTime={translateTime}
          classes={classes}
          style={internalStyleObject} />
        <TimeZoneWidget
          instructionalTextStyles="timeTimeZone"
          switchTimeZone={switchTimeZone}
          classes={classes}
          style={styleObject}
          widgetName="eventDateTime"
        />
      </div>
    );
  }
}

export default EventDateTimeWidget;
